export default "__VITE_ASSET__ff83a079__"